import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    zIndex,
    palette: { primary },
    breakpoints
  } = theme;

  return {
    root: {
      borderLeft: `1px solid ${primary.light}`
    },
    appPageHeader: {
      display: "grid",
      gridTemplateColumns: "auto min-content min-content",
      height: 50,
      borderBottom: `1px solid ${primary.light}`,
      padding: "0 24px",
      boxShadow: "none",
      [breakpoints.down("xs")]: {
        padding: "0 16px"
      }
    },
    appPageContent: {
      backgroundColor: "#fff",
      zIndex: zIndex.app.sidebar,
      boxShadow: "none"
    },
    appPageTableHeader: {
      display: "grid",
      gridTemplateColumns: "repeat(8, 1fr)",
      columnGap: 8,
      backgroundColor: "#fff",
      zIndex: 1,
      padding: "0 24px",
      height: 30,
      borderBottom: "1px solid rgba(204, 204, 204, 1)",
      [breakpoints.down(Breakpoints.SX_720)]: {
        gridTemplateColumns: "0.6fr 1fr 1fr 1.2fr 1.2fr 0.5fr 0.8fr 1fr",
        columnGap: 8
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        gridTemplateColumns: "49px auto",
        padding: 0
      }
    },
    appPageTableContent: {
      position: "relative"
    },
    displayingHorsesCount: {
      display: "flex",
      fontSize: "12px",
      color: primary.dark,
      margin: "0 16px",
      whiteSpace: "nowrap",
      alignItems: "center",
      [breakpoints.down(Breakpoints.SM_600)]: {
        margin: "0 12px"
      }
    },
    rowEven: {
      backgroundColor: "#f6f6f6"
    },
    rowOdd: {
      backgroundColor: "#fff"
    },
    tableHeaderCell: {
      display: "flex",
      height: 30,
      minHeight: 30,
      fontSize: 12,
      color: "#232323",
      whiteSpace: "nowrap",
      overflow: "hidden",
      "& .MuiSvgIcon-root": {
        width: 16
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        "&:first-child": {
          borderRight: "1px solid #e0e0e0",
          padding: "0 0 0 16px"
        }
      }
    },
    tableContentContainer: {
      position: "relative",
      overflow: "auto",
      willChange: "transform",
      direction: "ltr"
    },
    tableBodyRow: {
      minHeight: "50px",
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "repeat(8, 1fr)",
      columnGap: 8,
      cursor: "pointer",
      padding: "0 24px",
      [breakpoints.down(Breakpoints.SX_720)]: {
        gridTemplateColumns: "0.6fr 1fr 1fr 1.2fr 1.2fr 0.5fr 0.8fr 1fr",
        columnGap: 8
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        padding: "0",
        flexWrap: "wrap",
        columnGap: 0,
        gridTemplateColumns: "49px auto"
      }
    },
    sortIcon: {
      width: "6px",
      height: "6px"
    },
    filterButton: {
      padding: 9,
      "& .MuiSvgIcon-root": {
        fontSize: 30
      }
    },
    tableBodyCell: {
      textAlign: "left",
      [breakpoints.down(Breakpoints.SM_600)]: {
        display: "flex",
        flexWrap: "wrap",
        height: "100%",
        minHeight: "50px",
        fontSize: "12px",
        padding: "9px",
        alignItems: "center",
        "&:first-child": {
          borderRight: "1px solid #e0e0e0",
          padding: "0 0 0 16px"
        },
        "& > div": {
          display: "flex",
          background: "rgba(0, 0, 0, 0.1)",
          height: "28px",
          margin: "2px",
          alignItems: "center",
          padding: "0 7px",
          borderRadius: "2px",
          whiteSpace: "nowrap"
        }
      }
    },
    cellRight: {
      justifyContent: "flex-end",
      textAlign: "right"
    }
  };
});
